/* global globalThis */
import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";
import { getValidToken } from "../../utils/getValidToken";

export async function getPrioritizationMatrix(payload) {
    const requestObj = payload;
    try {
        const responseData = await authenticatedFetch(URL.prioritizationMatrix, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });

        return responseData;
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}

export async function updatePrioritizationMatrix(payload) {
    const requestObj = payload;
    try {
        const responseData = await authenticatedFetch(URL.updPrioritizationMatrix, {
            method: "PUT",
            body: JSON.stringify(requestObj)
        });

        return responseData;
    } catch (error) {
        console.error("Error updated data:", error.message);
        throw error;
    }
}
export async function insertPrioritizationMatrix(payload) {
    const requestObj = payload;
    try {
        const responseData = await authenticatedFetch(URL.addPrioritizationMatrix, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });

        return responseData;
    } catch (error) {
        console.error("Error added data:", error.message);
        throw error;
    }
}
export async function getCbuDetails(payload) {
    const requestObj = payload;
    try {
        const responseData = await authenticatedFetch(URL.get_cbu_details, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });

        return responseData;
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}
export async function getCbuWeekPlan() {
    try {
        const responseData = await authenticatedFetch(URL.getCbuWeekPlan, {
            method: "GET",
        });

        return responseData;
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}

export async function exportExcelFile(payload) {
    const requestObj = payload;
    const token = await getValidToken();

    try {
        const response = await fetch(URL.exportExcelPrioritization, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(requestObj),
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const blob = await response.blob();

        const url = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "exported_data_prioritization.xlsx");
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(url);

    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}